module.exports = __webpack_public_path__ + "media/images/app/news-4eaaddc1ec8a1411b4ae4da5b032214f.svg";